export const meta = {
  alias: 'logo-showcase',
  name: 'Logo Showcase',
  prefix: 'eapp-logo-showcase'
};
